/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Skeleton from '@mui/material/Skeleton';

import colors from '../../../constants/colors';

const CircularIntegration = ({ handleButtonClick, name, disabled, type, loadingButton, skeleton }) => {
    const useStyles = makeStyles(() => ({
        button: {
            marginTop: '0.5rem',
            fontFamily: 'Segoe UI',
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '14px',
            width: type === 'special' ? '65px' : '125px',
            color: disabled ? '#a0aab4 !important' : '#ffffff !important',
            background: disabled
                ? 'linear-gradient(135deg, #d0d8e0 0%, #e8edf2 100%)'
                : 'linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%)',
            boxShadow: disabled ? 'none' : '0 2px 8px rgba(0, 180, 220, 0.3)',
            border: 'none',
            borderRadius: '4px',
            '&:hover': {
                background: disabled
                    ? 'linear-gradient(135deg, #d0d8e0 0%, #e8edf2 100%)'
                    : 'linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%)',
                color: disabled ? '#a0aab4 !important' : '#1a5fa8 !important',
                boxShadow: disabled ? 'none' : '0 2px 8px rgba(0, 140, 200, 0.25)',
            },
            letterSpacing: '0',
            textTransform: 'none !important',
            transition: 'all 0.2s ease',
        },
        circular: {
            color: colors.blue,
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-10px',
            marginLeft: '-10px',
        }
    }));
    const classes = useStyles();
    const [loading, setLoading] = useState(loadingButton);
    const [disabledButton, setDisabledButton] = useState(disabled);

    useEffect(() => {
        setDisabledButton(disabled);
    }, [disabled]);
    useEffect(() => {
        setLoading(loadingButton);
    }, [loadingButton]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: '4px', position: 'relative' }}>
                {skeleton ? <Skeleton width={125} height={60} /> : 
                <Button
                    className={classes.button}
                    disabled={disabledButton}
                    onClick={handleButtonClick}
                >
                    {name}
                </Button>}
                {loading && <CircularProgress className={classes.circular} size={24} />}
            </Box>
        </Box>
    )
}

CircularIntegration.propTypes = {
    handleButtonClick: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    loadingButton: PropTypes.bool,
    skeleton: PropTypes.bool
}

CircularIntegration.defaultProps = {
    disabled: false,
    type: null,
    loadingButton: false,
    skeleton: false
}

export default CircularIntegration;
